import { RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material"
import { GRID_FORM_CONFIG_T } from "../../../../../common/FormGenerator"
import { AutocompleteInput } from "../../../../../components/ui-kit/AutocompleteInput"
import { russiaRegionsOptions } from "../../../../../consts/russiaRegions"
import { normalizeTagsForTyping } from "./helpers/tags"
import { normalizeExternalLinksForDisplay } from "./helpers/externalLinks"
import { EXTERNAL_LINKS_MAX } from "../../../../../consts/projectExternalLinks"
import { RadioGroupStyle } from "./style"
import { PROJECT_STATUS_OPTIONS, PROJECT_TYPE_OPTIONS, ProjectStageEnum } from "../../../../../consts/projectTypeOptions"

export type FiltrationBlockName =
    | "name"
    | "stage"
    | "region"
    | "description"
    | "full_description"
    | "env_factor"
    | "expected_result"
    | "necessary_actions"
    | "initial_state"
    | "implementation"
    | "type"
    | "tags"
    | "city"
    | "address"
    | "website"
    | "external_links"
    | "status"

export const nameConfig = [
    [
        {
            id: 1,
            controllerName: "name",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Название — до 500 символов",
                fullWidth: true,
                size: "small",
                inputProps: { maxLength: 500 },
            }),
        },
    ],
]

export const stageConfig = [
    [
        {
            id: 2,
            controllerName: "stage",
            RenderElement: RadioGroup,
            renderProps: () => ({
                row: true,
                sx: RadioGroupStyle,
                children: [
                    <FormControlLabel key={1} value={ProjectStageEnum.IDEA} control={<Radio />} label="1. Идея" />,
                    <FormControlLabel key={2} value={ProjectStageEnum.PLANNING} control={<Radio />} label="2. Планирование" />,
                    <FormControlLabel key={3} value={ProjectStageEnum.IMPLEMENTATION} control={<Radio />} label="3. Реализация" />,
                    <FormControlLabel key={4} value={ProjectStageEnum.TESTING} control={<Radio />} label="4. Тестирование" />,
                    <FormControlLabel key={5} value={ProjectStageEnum.COMPLETED} control={<Radio />} label="5. Работает" />,
                    <FormControlLabel key={6} value={ProjectStageEnum.PHASE_SIX} control={<Radio />} label="6. Завершён" />,
                ],
            })
        }
    ]
]

export const regionConfig = [
    [
        {
            id: 3,
            controllerName: "region",
            RenderElement: AutocompleteInput,
            renderProps: (formProps: any) => ({
                options: russiaRegionsOptions,
                freeSolo: false,
                fullWidth: true,
                size: "small",
                placeholder: "Выберите регион",
                error: Boolean(formProps.error),
                helperText: formProps.helperText,
            }),
        }
    ]
]

export const descriptionConfig = [
    [
        {
            id: 4,
            controllerName: "description",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Краткое описание проекта...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const fullDescriptionConfig = [
    [
        {
            id: 16,
            controllerName: "full_description",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Полное описание проекта...",
                fullWidth: true,
                multiline: true,
                minRows: 4,
                size: "small",
            }),
        },
    ],
]

export const envFactorConfig = [
    [
        {
            id: 5,
            controllerName: "env_factor",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Укажите, что для вас является проблемой с целью которой запускается проект...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const expectedResultConfig = [
    [
        {
            id: 6,
            controllerName: "expected_result",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Какова должна быть конечная цель проекта...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const initialStateConfig = [
    [
        {
            id: 7,
            controllerName: "initial_state",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Конкретные шаги и запросы, необходимые для реализации...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const necessaryActionsConfig = [
    [
        {
            id: 8,
            controllerName: "necessary_actions",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Какого положение дел на текущий момент...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const implementationConfig = [
    [
        {
            id: 9,
            controllerName: "implementation",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Какие инструменты будут задействованы...",
                fullWidth: true,
                multiline: true,
                size: "small",
            }),
        },
    ],
]

export const typeConfig = [
    [
        {
            id: 10,
            controllerName: "type",
            RenderElement: AutocompleteInput,
            renderProps: (formProps: any) => ({
                options: PROJECT_TYPE_OPTIONS,
                freeSolo: false,
                disableClearable: true,
                fullWidth: true,
                size: "small",
                placeholder: "Выберите тип проекта",
                error: formProps.error,
            }),
        }
    ]
]

export const tagsConfig = [
    [
        {
            id: 11,
            controllerName: "tags",
            RenderElement: TextField,
            renderProps: (formProps: any) => ({
                placeholder: "Введите теги через пробел или запятую (например: #эко город энергия)",
                fullWidth: true,
                size: "small",
                multiline: true,
                onInput: (e: any) => {
                    const normalized = normalizeTagsForTyping(String(e?.target?.value ?? ""))
                    e.target.value = normalized
                    formProps?.field?.onChange?.(e)
                },
            }),
        },
    ],
]

export const cityConfig = [
    [
        {
            id: 12,
            controllerName: "city",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Введите город",
                fullWidth: true,
                size: "small",
                inputProps: { maxLength: 60 },
            }),
        },
    ],
]

export const addressConfig = [
    [
        {
            id: 13,
            controllerName: "address",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Введите адрес",
                fullWidth: true,
                size: "small",
                inputProps: { maxLength: 60 },
            }),
        },
    ],
]

export const websiteConfig = [
    [
        {
            id: 14,
            controllerName: "website",
            RenderElement: TextField,
            renderProps: () => ({
                placeholder: "Введите URL сайта",
                fullWidth: true,
                size: "small",
                inputProps: { type: "url" },
            }),
        },
    ],
]

export const externalLinksConfig = [
    [
        {
            id: 16,
            controllerName: "external_links",
            RenderElement: TextField,
            renderProps: (formProps: any) => ({
                placeholder: `Ссылки через пробел, запятую или с новой строки (до ${EXTERNAL_LINKS_MAX})`,
                fullWidth: true,
                size: "small",
                multiline: true,
                minRows: 3,
                maxRows: 12,
                // FormGenerator spreads `field` after renderProps and overwrites onBlur —
                // use capture so we still pretty-print one URL per line.
                onBlurCapture: (e: any) => {
                    const current = String(e?.target?.value ?? "")
                    const pretty = normalizeExternalLinksForDisplay(current)
                    if (pretty !== current) {
                        formProps?.field?.onChange?.(pretty)
                    }
                },
            }),
        },
    ],
]

export const statusConfig = [
    [
        {
            id: 15,
            controllerName: "status",
            RenderElement: AutocompleteInput,
            renderProps: (formProps: any) => ({
                options: PROJECT_STATUS_OPTIONS,
                freeSolo: false,
                disableClearable: true,
                fullWidth: true,
                size: "small",
                placeholder: "Выберите статус проекта",
                error: formProps.error,
            }),
        }
    ]
]

const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<any>> = {
    name: nameConfig,
    stage: stageConfig,
    region: regionConfig,
    description: descriptionConfig,
    full_description: fullDescriptionConfig,
    env_factor: envFactorConfig,
    expected_result: expectedResultConfig,
    necessary_actions: necessaryActionsConfig,
    initial_state: initialStateConfig,
    implementation: implementationConfig,
    type: typeConfig,
    tags: tagsConfig,
    city: cityConfig,
    address: addressConfig,
    website: websiteConfig,
    external_links: externalLinksConfig,
    status: statusConfig,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]

export const getDynamicConfig = (blockName: FiltrationBlockName, index: number, arrayName: string): GRID_FORM_CONFIG_T<any> => {
    const config = getFormConfig(blockName);
    
    return [...config.map(row => 
        row.map(field => ({
            ...field,
            controllerName: `${arrayName}.${index}.${field.controllerName}`
        }))
    )];
};
